import { GetAccountResponse } from "../models/get-account-response";
import { get } from "./utils";

export const getAccount = async (url: string) => await get<GetAccountResponse>(url);
